import FilteredProductsList from './filteredProductsList'

export default FilteredProductsList
